import styled, { css } from 'styled-components';
import { colors, ApInput } from '@alixpartners/ui-components';

interface IRowProps {
  isInvalid?: boolean;
  isHighlighted?: boolean;
}

export const TextTruncate = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Label = styled(TextTruncate)`
  font-size: 13px;
  line-height: 19px;
  letter-spacing: 0.3px;
  color: ${colors.black};
  padding: 0 4px;
`;

export const Cell = styled.div`
  display: flex;
  font-size: 13px;
  letter-spacing: 0.3px;
  line-height: 20px;
  color: ${colors.grey8};
  overflow: hidden;
  align-items: center;
`;

export const CellIcon = styled(Cell)`
  align-items: center;
  justify-content: center;
`;

export const GridRow = styled.div<IRowProps>`
  padding: 4px 12px;
  display: grid;
  grid-template-columns: 1fr minmax(71px, 71px) minmax(45px, 45px);
  grid-gap: 10px;
  width: 100%;
  cursor: default;

  ${({ isHighlighted, isInvalid }) => {
    if (isInvalid) {
      return css`
        background-color: rgba(238, 58, 54, 0.1);
      `;
    }

    if (isHighlighted) {
      return css`
        background-color: ${colors.green0};
      `;
    }
  }}
`;

export const StyledInput = styled(ApInput)`
  background-color: white;

  input {
    min-width: 71px;
  }
`;
